import { createIcon } from '@chakra-ui/react';
import React from 'react';

const displayName = `Logo`;

const viewBox = `0 0 121.55 50`;

const path = (
  <>
    <path
      d="M64.27,6.36a1.85,1.85,0,0,1,3.16-1.31,1.84,1.84,0,0,1,0,2.62,1.86,1.86,0,0,1-3.16-1.31Zm3.26,19.78A8.63,8.63,0,0,1,67.32,28a10.19,10.19,0,0,1-.6,1.87,9.3,9.3,0,0,1-1,1.71,5.94,5.94,0,0,1-1.31,1.34,1.36,1.36,0,0,1-.87.31,1.33,1.33,0,0,1-1-.45,1.51,1.51,0,0,1-.42-1,1,1,0,0,1,.27-.77c.18-.16.37-.35.58-.55a5.56,5.56,0,0,0,1.27-2,6.27,6.27,0,0,0,.44-2.3V12.24a1.27,1.27,0,0,1,.44-1.06,1.51,1.51,0,0,1,1.93,0,1.26,1.26,0,0,1,.44,1.06Z"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M77.92,19.57l-3,.67a4.05,4.05,0,0,0-2.08,1A2.1,2.1,0,0,0,73,24.37a3.08,3.08,0,0,0,2.1.65,2.91,2.91,0,0,0,2.08-.74,2.45,2.45,0,0,0,.79-1.84Zm2.81,2.86a5.26,5.26,0,0,1-.46,2.22A5.51,5.51,0,0,1,79,26.35a5.67,5.67,0,0,1-1.8,1.1,6.27,6.27,0,0,1-2.14.38A7,7,0,0,1,73,27.51a5.73,5.73,0,0,1-1.83-1A4.59,4.59,0,0,1,69.88,25a5,5,0,0,1-.48-2.22,4.54,4.54,0,0,1,.45-2A5.23,5.23,0,0,1,71,19.19a6.1,6.1,0,0,1,1.69-1,11.27,11.27,0,0,1,2-.62l3.23-.7V16a2.69,2.69,0,0,0-.65-1.88,2.75,2.75,0,0,0-2.14-.7,2.62,2.62,0,0,0-1.26.26,5,5,0,0,0-.83.59,7.23,7.23,0,0,1-.69.59,1.28,1.28,0,0,1-.84.27,1.45,1.45,0,0,1-1-.39,1.37,1.37,0,0,1-.42-1,1.56,1.56,0,0,1,.14-.63,2.14,2.14,0,0,1,.37-.52,5.24,5.24,0,0,1,2-1.47A6.62,6.62,0,0,1,77.47,11a5.25,5.25,0,0,1,1.77,1.13,4.82,4.82,0,0,1,1.11,1.7A5.89,5.89,0,0,1,80.73,16Z"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M83,12.23a1.24,1.24,0,0,1,.44-1.05,1.48,1.48,0,0,1,1-.35,1.52,1.52,0,0,1,1,.35,1.26,1.26,0,0,1,.43,1.05V26.14a1.3,1.3,0,0,1-.43,1.06,1.58,1.58,0,0,1-1,.35,1.54,1.54,0,0,1-1-.35A1.27,1.27,0,0,1,83,26.14Zm-.45-5.87A1.88,1.88,0,0,1,84.44,4.5a1.82,1.82,0,0,1,1.3.55,1.84,1.84,0,0,1,0,2.62,1.85,1.85,0,0,1-2.61,0A1.86,1.86,0,0,1,82.58,6.36Z"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M106.67,27.19a1.52,1.52,0,0,1-1.94,0,1.26,1.26,0,0,1-.43-1.05V16a2.56,2.56,0,0,0-.22-1,2.6,2.6,0,0,0-1.43-1.43,2.55,2.55,0,0,0-1-.21,2.31,2.31,0,0,0-1,.21,2.59,2.59,0,0,0-.85.57,2.75,2.75,0,0,0-.57.86A2.55,2.55,0,0,0,99,16V26.14a1.34,1.34,0,0,1-.44,1.1,1.46,1.46,0,0,1-1.94,0,1.3,1.3,0,0,1-.43-1.1V16a2.55,2.55,0,0,0-.21-1,2.78,2.78,0,0,0-.58-.86,2.75,2.75,0,0,0-.86-.57,2.55,2.55,0,0,0-1-.21,2.31,2.31,0,0,0-1,.21,2.7,2.7,0,0,0-.85.57A2.75,2.75,0,0,0,91,15a2.55,2.55,0,0,0-.21,1V26.14a1.27,1.27,0,0,1-.44,1.06,1.54,1.54,0,0,1-1,.35,1.58,1.58,0,0,1-1-.35A1.3,1.3,0,0,1,88,26.14V16a5.2,5.2,0,0,1,.43-2.13,5.55,5.55,0,0,1,1.17-1.74A5.68,5.68,0,0,1,91.33,11a5.54,5.54,0,0,1,4.42.06,5.4,5.4,0,0,1,1.8,1.34A5.61,5.61,0,0,1,99.35,11a5.26,5.26,0,0,1,2.28-.49,5.37,5.37,0,0,1,2.13.43,5.71,5.71,0,0,1,1.75,1.17,5.52,5.52,0,0,1,1.16,1.74,5.43,5.43,0,0,1,.44,2.14V26.14a1.34,1.34,0,0,1-.44,1.06"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M121.52,12.17a1.24,1.24,0,0,1,0,.27,2.76,2.76,0,0,1-.08.27l-7.28,19.53a1.28,1.28,0,0,1-1.27.93,1.59,1.59,0,0,1-1-.37,1.28,1.28,0,0,1-.42-1.25,1.43,1.43,0,0,1,.09-.27l2-5.2-4.86-13.23a1.91,1.91,0,0,1-.1-.34,1.27,1.27,0,0,1,0-.34,1.18,1.18,0,0,1,.45-1,1.55,1.55,0,0,1,1-.37,1.47,1.47,0,0,1,.76.23,1.29,1.29,0,0,1,.53.7L115,22.29l3.82-10.54a1.28,1.28,0,0,1,.52-.71,1.44,1.44,0,0,1,.75-.21,1.54,1.54,0,0,1,1,.36,1.22,1.22,0,0,1,.45,1"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M67.74,40.59a1.53,1.53,0,0,0-.6.12,1.63,1.63,0,0,0-.49.33,1.43,1.43,0,0,0-.32.49,1.53,1.53,0,0,0-.12.6V44.6a1.57,1.57,0,0,0,.12.6,1.39,1.39,0,0,0,.32.48,1.63,1.63,0,0,0,.49.33,1.56,1.56,0,0,0,1.2,0,1.63,1.63,0,0,0,.49-.33,1.39,1.39,0,0,0,.32-.48,1.41,1.41,0,0,0,.13-.6V42.13a1.38,1.38,0,0,0-.13-.6,1.43,1.43,0,0,0-.32-.49,1.63,1.63,0,0,0-.49-.33A1.53,1.53,0,0,0,67.74,40.59Zm-1.53-.76a2.27,2.27,0,0,1,.68-.42,2.45,2.45,0,0,1,.85-.15,2.68,2.68,0,0,1,1.12.23A2.83,2.83,0,0,1,70.38,41a2.84,2.84,0,0,1,.23,1.12V44.6a2.71,2.71,0,0,1-.23,1.12,2.83,2.83,0,0,1-1.52,1.52,2.84,2.84,0,0,1-2.24,0,2.83,2.83,0,0,1-1.52-1.52,2.84,2.84,0,0,1-.23-1.12V37.06a.61.61,0,0,1,.21-.5.74.74,0,0,1,.92,0,.64.64,0,0,1,.21.5Z"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M77.18,40a.53.53,0,0,1,0,.13.65.65,0,0,1,0,.13l-3.46,9.27a.61.61,0,0,1-.25.34.6.6,0,0,1-.35.1.78.78,0,0,1-.48-.17.58.58,0,0,1-.21-.47.57.57,0,0,1,0-.13.56.56,0,0,1,0-.12l1-2.47-2.31-6.29a.75.75,0,0,1,0-.16A.41.41,0,0,1,71,40a.55.55,0,0,1,.21-.46.74.74,0,0,1,.48-.18.66.66,0,0,1,.36.11.63.63,0,0,1,.25.33l1.75,5,1.82-5a.6.6,0,0,1,.24-.34.75.75,0,0,1,.36-.1.74.74,0,0,1,.48.18.55.55,0,0,1,.21.46"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M86,44.17a1.71,1.71,0,0,0-.15-.71,1.77,1.77,0,0,0-1-1,1.74,1.74,0,0,0-.71-.15H82V46h2.11a1.74,1.74,0,0,0,.71-.15,2,2,0,0,0,.59-.39,1.85,1.85,0,0,0,.39-.58A1.78,1.78,0,0,0,86,44.17ZM82,41h2.11a1.69,1.69,0,0,0,.63-.13,1.58,1.58,0,0,0,.53-.35,1.64,1.64,0,0,0,.48-1.15,1.56,1.56,0,0,0-.13-.64,1.64,1.64,0,0,0-.35-.52,1.47,1.47,0,0,0-.53-.36,1.51,1.51,0,0,0-.63-.12H82Zm5.28,3.16a3,3,0,0,1-.25,1.24,3.23,3.23,0,0,1-.68,1,2.86,2.86,0,0,1-1,.68,3.08,3.08,0,0,1-1.23.25H81.37a.68.68,0,0,1-.66-.67v-9.6a.68.68,0,0,1,.66-.67h2.78a2.82,2.82,0,0,1,1.15.24,2.92,2.92,0,0,1,1,.63,3,3,0,0,1,.64.94,2.89,2.89,0,0,1,.24,1.15,2.66,2.66,0,0,1-.35,1.32,2.37,2.37,0,0,1-1,1,3.28,3.28,0,0,1,.56.42,3.56,3.56,0,0,1,.49.6,2.76,2.76,0,0,1,.35.71,2.35,2.35,0,0,1,.14.79Z"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M92.56,42.13a1.53,1.53,0,0,0-.12-.6,1.54,1.54,0,0,0-.82-.82,1.53,1.53,0,0,0-.6-.12,1.49,1.49,0,0,0-1.08.45,1.63,1.63,0,0,0-.33.49,1.53,1.53,0,0,0-.12.6v.26h3.07Zm1.33.93a.68.68,0,0,1-.67.67H89.49v.87a1.29,1.29,0,0,0,.13.58,1.58,1.58,0,0,0,.37.48,1.77,1.77,0,0,0,.53.34,1.56,1.56,0,0,0,.64.13,2.06,2.06,0,0,0,.7-.12,1.6,1.6,0,0,0,.59-.39.66.66,0,0,1,.54-.3.67.67,0,0,1,.48.2.61.61,0,0,1,.21.46.68.68,0,0,1-.13.39.16.16,0,0,0,0,.07l-.14.14a2.56,2.56,0,0,1-1,.67,3.53,3.53,0,0,1-1.2.21A2.73,2.73,0,0,1,90,47.24a3.44,3.44,0,0,1-1-.6,3.16,3.16,0,0,1-.67-.91,2.46,2.46,0,0,1-.25-1.13V42.13A2.67,2.67,0,0,1,88.38,41,3,3,0,0,1,89,40.1a2.87,2.87,0,0,1,.9-.61,2.87,2.87,0,0,1,2.25,0,2.87,2.87,0,0,1,.9.61,3,3,0,0,1,.62.91,2.67,2.67,0,0,1,.22,1.12Z"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M95.49,37.06a.59.59,0,0,1,.21-.5.71.71,0,0,1,.92,0,.62.62,0,0,1,.21.5v9.6a.62.62,0,0,1-.21.5.71.71,0,0,1-.92,0,.62.62,0,0,1-.21-.5Z"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M102.71,37.27a.68.68,0,0,1-.15.45.52.52,0,0,1-.41.18.63.63,0,0,1-.19,0,1,1,0,0,1-.21-.09,1.51,1.51,0,0,0-.29-.13,1.13,1.13,0,0,0-.36-.06,1,1,0,0,0-.73.25.79.79,0,0,0-.23.56v1h1.73a.59.59,0,0,1,.5.21.71.71,0,0,1,0,.92.62.62,0,0,1-.5.21h-1.73v5.93a.59.59,0,0,1-.21.5.71.71,0,0,1-.92,0,.62.62,0,0,1-.21-.5V40.73h-.94a.62.62,0,0,1-.5-.21.71.71,0,0,1,0-.92.59.59,0,0,1,.5-.21h.94v-1a2.18,2.18,0,0,1,.18-.86,2,2,0,0,1,.49-.68,2.26,2.26,0,0,1,.73-.44,2.52,2.52,0,0,1,.9-.17,2.71,2.71,0,0,1,.75.1,1.45,1.45,0,0,1,.5.24,1,1,0,0,1,.28.33.85.85,0,0,1,.08.35"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M104,40.06a.64.64,0,0,1,.21-.5.71.71,0,0,1,.92,0,.64.64,0,0,1,.21.5v6.6a.62.62,0,0,1-.21.5.71.71,0,0,1-.92,0,.62.62,0,0,1-.21-.5Zm-.21-2.79a.88.88,0,0,1,1.76,0,.84.84,0,0,1-.26.62.87.87,0,0,1-1.24,0A.84.84,0,0,1,103.82,37.27Z"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M118.66,45.09a2,2,0,0,1-.23,1,2.46,2.46,0,0,1-.61.75,2.65,2.65,0,0,1-.88.46,3.24,3.24,0,0,1-1,.16,3.18,3.18,0,0,1-.62-.06,3.55,3.55,0,0,1-.63-.2,2.52,2.52,0,0,1-.58-.32,1.85,1.85,0,0,1-.43-.45.62.62,0,0,1-.13-.4.6.6,0,0,1,.21-.46.67.67,0,0,1,.48-.2.7.7,0,0,1,.53.29,1.27,1.27,0,0,0,.54.38,1.66,1.66,0,0,0,.62.11,1.58,1.58,0,0,0,.62-.09,1.24,1.24,0,0,0,.45-.25,1,1,0,0,0,.26-.34.85.85,0,0,0,.09-.38.82.82,0,0,0-.28-.66,2.67,2.67,0,0,0-.7-.44q-.41-.18-.9-.36a5.4,5.4,0,0,1-.9-.45,2.48,2.48,0,0,1-.69-.68,1.83,1.83,0,0,1-.28-1.07,2,2,0,0,1,.77-1.63,2.44,2.44,0,0,1,.78-.41,2.93,2.93,0,0,1,.88-.13,2.65,2.65,0,0,1,.63.08,2.8,2.8,0,0,1,.63.23,2.63,2.63,0,0,1,.56.38,2.18,2.18,0,0,1,.43.48.63.63,0,0,1,.11.38.61.61,0,0,1-.21.47.71.71,0,0,1-.48.19.68.68,0,0,1-.54-.32,1.29,1.29,0,0,0-1.13-.58,1.11,1.11,0,0,0-.82.26.78.78,0,0,0-.28.6.69.69,0,0,0,.28.56,3.21,3.21,0,0,0,.7.39c.27.12.57.23.9.36a3.9,3.9,0,0,1,.9.48,2.56,2.56,0,0,1,.69.74,2,2,0,0,1,.28,1.13"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <path
      d="M112.41,45.72a3,3,0,0,1-.62.91,2.8,2.8,0,0,1-.91.61,2.84,2.84,0,0,1-1.12.23,2.91,2.91,0,0,1-1.12-.23,2.76,2.76,0,0,1-.9-.61,3,3,0,0,1-.62-.91,2.84,2.84,0,0,1-.23-1.12V40.06a.64.64,0,0,1,.21-.5.71.71,0,0,1,.92,0,.61.61,0,0,1,.21.5V44.6a1.52,1.52,0,0,0,1.53,1.53,1.53,1.53,0,0,0,.6-.12,1.63,1.63,0,0,0,.49-.33,1.49,1.49,0,0,0,.45-1.08V40.06a.6.6,0,0,1,.2-.5.71.71,0,0,1,.92,0,.61.61,0,0,1,.21.5V44.6a2.74,2.74,0,0,1-.23,1.12"
      transform="translate(0.03)"
      style={{
        fill: `#aaacb6`,
        opacity: 0.7000000000000001,
      }}
    />
    <rect
      x="0.03"
      y="8.28"
      width="29.42"
      height="29.42"
      style={{ fill: `none` }}
    />
    <path
      d="M14.68,37.69a14.71,14.71,0,1,1,0-29.41A2.71,2.71,0,0,1,17.39,11h0a2.71,2.71,0,0,1-2.71,2.71h0A9.29,9.29,0,1,0,24,23a2.71,2.71,0,1,1,5.42,0,14.71,14.71,0,0,1-14.7,14.7"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
    <path
      d="M39.84,29.42a2.71,2.71,0,0,1-2.71-2.72h0A2.71,2.71,0,0,1,39.84,24a9.29,9.29,0,1,0-9.28-9.29,2.71,2.71,0,0,1-2.71,2.72h0a2.72,2.72,0,0,1-2.72-2.71h0A14.71,14.71,0,1,1,39.84,29.42"
      transform="translate(0.03)"
      style={{
        fill: `#c4163a`,
      }}
    />
  </>
);

export const Logo = createIcon({ displayName, viewBox, path });
